export default {
  isWidgetReady: false,
  business: {
    message: "Order now and get your favorite food delivered to your doorstep.",
    title: "Hey there, 👋",
    theme_color: "#058eff",
    text_color: "#ffffff",
    widget_type: "default"
  }
};
